export enum DocumentTemplateType {
  EOI = 'EOI',
  PAS4 = 'PAS4',
}

export default DocumentTemplateType;
